'use strict';
/**
 * Error raised when there is lock already in place when repo is being opened.
 */

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var LockExistsError = /*#__PURE__*/function (_Error) {
  _inherits(LockExistsError, _Error);

  var _super = _createSuper(LockExistsError);

  function LockExistsError(message) {
    var _this;

    _classCallCheck(this, LockExistsError);

    _this = _super.call(this, message);
    _this.name = 'LockExistsError';
    _this.code = LockExistsError.code;
    return _this;
  }

  return LockExistsError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

LockExistsError.code = 'ERR_LOCK_EXISTS';
exports.LockExistsError = LockExistsError;
/**
 * Error raised when requested item is not found.
 */

var NotFoundError = /*#__PURE__*/function (_Error2) {
  _inherits(NotFoundError, _Error2);

  var _super2 = _createSuper(NotFoundError);

  function NotFoundError(message) {
    var _this2;

    _classCallCheck(this, NotFoundError);

    _this2 = _super2.call(this, message);
    _this2.name = 'NotFoundError';
    _this2.code = NotFoundError.code;
    return _this2;
  }

  return NotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

NotFoundError.code = 'ERR_NOT_FOUND';
exports.NotFoundError = NotFoundError;
/**
 * Error raised when version of the stored repo is not compatible with version of this package.
 */

var InvalidRepoVersionError = /*#__PURE__*/function (_Error3) {
  _inherits(InvalidRepoVersionError, _Error3);

  var _super3 = _createSuper(InvalidRepoVersionError);

  function InvalidRepoVersionError(message) {
    var _this3;

    _classCallCheck(this, InvalidRepoVersionError);

    _this3 = _super3.call(this, message);
    _this3.name = 'InvalidRepoVersionError';
    _this3.code = InvalidRepoVersionError.code;
    return _this3;
  }

  return InvalidRepoVersionError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

InvalidRepoVersionError.code = 'ERR_INVALID_REPO_VERSION';
exports.InvalidRepoVersionError = InvalidRepoVersionError;
exports.ERR_REPO_NOT_INITIALIZED = 'ERR_REPO_NOT_INITIALIZED';
exports.ERR_REPO_ALREADY_OPEN = 'ERR_REPO_ALREADY_OPEN';
exports.ERR_REPO_ALREADY_CLOSED = 'ERR_REPO_ALREADY_CLOSED';